import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import { authStore } from '@/store/authStore'
import NotificacoesAdminPage from '@/pages/notificacoes/NotificacoesAdminPage'
import NotificacoesPage from '@/pages/notificacoes/NotificacoesPage'

/**
 * Rotas do A14 (Onda 7.4) — `/notificacoes` despachado por papel: o back-office
 * (ADMIN/GERENTE/OPERADOR) abre a central de notificações (histórico global, resumo,
 * Reprocessar); o consultor abre a própria caixa de notificações (A16, Onda 8 —
 * `GET /v1/notificacoes` do usuário do token, CTA por tipo de evento).
 *
 * Campanhas (7.5) não ganha rota nova: o detalhe (Regra · Participantes · Ranking) abre
 * no drawer da página já registrada em `campanhas`.
 */
const NotificacoesPorPapel: FC = () => {
  const usuario = authStore((s) => s.usuario)
  const ehBackoffice = !!usuario?.permissoes?.some((p) => {
    const up = p.toUpperCase()
    return up === 'ADMIN' || up === 'GERENTE' || up === 'OPERADOR'
  })
  return ehBackoffice ? <NotificacoesAdminPage /> : <NotificacoesPage />
}

const rotasA14: RouteObject[] = [{ path: 'notificacoes', element: <NotificacoesPorPapel /> }]

export default rotasA14
